import { Fragment } from "react"
import { Link, useLocation } from "react-router-dom"

import type { BreadcrumbItem } from "../types/complex-breadcrumb-item"
import { isComplexBreadcrumbItem } from "../types/complex-breadcrumb-item"
import { ComplexBreadcrumbRenderer } from "./complex-breadcrumb-renderer"

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const location = useLocation()

  if (!items || items.length === 0) return null

  return (
    <nav className="breadcrumb flex items-center text-sm font-light text-t100 md:text-base">
      {items.map((item, index) => {
        // Handle complex breadcrumb items
        if (isComplexBreadcrumbItem(item)) {
          return (
            <Fragment key={index}>
              {index > 0 && <BreadcrumbSeparator />}
              <div className="flex items-center">
                <ComplexBreadcrumbRenderer item={item} />
              </div>
            </Fragment>
          )
        }

        // Handle simple navigation items (existing logic)
        if (!item.href) {
          return (
            <Fragment key={index}>
              {index > 0 && <BreadcrumbSeparator />}
              <div className="simple flex items-center">
                <span className={item.isActive(location) ? "" : ""}>{item.label}</span>
              </div>
            </Fragment>
          )
        }

        if (item.href && !item.isExternal) {
          return (
            <Fragment key={index}>
              {index > 0 && <BreadcrumbSeparator />}
              <div className="href-internal mx-2 flex items-center">
                <Link to={item.generateHref()} className={`${item.isActive(location) ? "" : ""}`}>
                  {item.label}
                </Link>
              </div>
            </Fragment>
          )
        }

        if (item.href && item.isExternal) {
          return (
            <Fragment key={index}>
              {index > 0 && <BreadcrumbSeparator />}
              <div className="href-external flex items-center">
                <a
                  href={item.href}
                  className={`${item.isActive(location) ? "font-medium" : ""}`}
                  target="_blank"
                  rel="noreferrer noopen"
                >
                  {item.label}
                </a>
              </div>
            </Fragment>
          )
        }
        return null
      })}
    </nav>
  )
}

const BreadcrumbSeparator = () => {
  return <span className="separator text-secondary-500 md:mx-1">❯</span>
}
